<div role="group" aria-live="polite" aria-atomic="true">
  <dt>
    <button
      class="w-full flex justify-between min-h-14 items-center cursor-pointer"
      (click)="isOpen = !isOpen"
    >
      <div
        class="text-mobileMd text-start tablet:text-tabletMd text-black pr-3 desktop:text-desktopMd py-3"
      >
        {{ faqItem.question }}
      </div>
      <sc-svg
        name="arrow-down"
        size="w-5 h-5"
        class="transform transition-transform duration-300"
        [ngClass]="isOpen ? 'rotate-180 pl-1.5' : 'pr-1.5'"
      ></sc-svg>
    </button>
  </dt>
  <div [attr.aria-hidden]="!isOpen">
    @if (isOpen) {
      <div @faqItemAnimation>
        <dd
          class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd pb-3 text-secondaryText faq-answer"
          [innerHTML]="faqItem.answer"
        ></dd>
      </div>
    }
  </div>
</div>
